import type { PlayerId } from "./types/common";
import type { PlayerZones, WarchestState } from "./types/game-state";
import { getOpponent } from "./utils/zone-utils";

// "UNKNOWN" sentinel preserves zone lengths for opponent hand/bag/facedown discard
// while hiding coin identity. UI can check `coinType === "UNKNOWN"` to show card backs.
const UNKNOWN = "UNKNOWN";

function redactOpponentZones(zones: PlayerZones): PlayerZones {
  return {
    ...zones,
    bag: zones.bag.map(() => UNKNOWN),
    hand: zones.hand.map(() => UNKNOWN),
    discardFaceDown: zones.discardFaceDown.map(() => UNKNOWN),
  };
}

export function redactGameState(
  state: WarchestState,
  viewingPlayer: PlayerId,
): WarchestState {
  const opponent = getOpponent(viewingPlayer);
  return {
    ...state,
    playerZones: {
      ...state.playerZones,
      [opponent]: redactOpponentZones(state.playerZones[opponent]),
    },
  };
}
